'use client';
import { fetchQuestionDetail } from '@/apis/help/help.api';
import { useEffect, useState } from 'react';
import styles from './index.module.scss';
import TipsArrowPopover from './tipsArrowPopover';
interface CountdownProps {
  countdown: number;
  curTimeField?: number;
  timeEndCallback?: () => void;
}
// duration 时间差 ms
const duration2HMS = (duration: number) => {
  duration = Math.max(~~duration, 0);
  const s = duration % 60;
  const m = ~~(duration / 60) % 60;
  const h = ~~(duration / 60 / 60);
  return { h, m, s };
};

export function Countdown({ countdown, curTimeField, timeEndCallback }: CountdownProps) {
  const start = curTimeField || new Date().getTime();
  const realCountDown = countdown + (start - new Date().getTime()) / 1000;
  const [hour, setHour] = useState(duration2HMS(realCountDown).h);
  const [minute, setMinute] = useState(duration2HMS(realCountDown).m);
  const [second, setSecond] = useState(duration2HMS(realCountDown).s);

  const refreshCountdown = () => {
    const { s, m, h } = duration2HMS(countdown + (start - new Date().getTime()) / 1000);
    setHour(h);
    setMinute(m);
    setSecond(s);
    if (s === 0 && m === 0 && h === 0) {
      return -1;
    } else {
      return 1;
    }
  };
  useEffect(() => {
    refreshCountdown();
    const countdownTimer = setInterval(() => {
      const status = refreshCountdown();
      if (status === -1) {
        clearInterval(countdownTimer);
        if (timeEndCallback) {
          timeEndCallback();
        } else {
          window.location.reload();
        }
      }
    }, 200);
    return () => {
      clearInterval(countdownTimer);
    };
  }, [countdown, curTimeField]);
  return (
    <span className={styles.part_item} suppressHydrationWarning={true}>
      {(hour + '').padStart(2, '0')}:{(minute + '').padStart(2, '0')}:
      {(second + '').padStart(2, '0')}
    </span>
  );
}

export default function BrandLaunch({
  countdown,
  curTimeField,
  desc,
  promotionPop,
  promotionTimeText,
}: any) {
  const { sceneId, title } = promotionPop || {};
  const [tipsContent, setTipsContent] = useState('');
  const queryTipsContent = async () => {
    const { data, code } = await fetchQuestionDetail({ scene: sceneId });
    if (code === '200' && data?.facadeContent) {
      setTipsContent(data.facadeContent);
    }
  };

  useEffect(() => {
    // 延迟查询，避免阻塞重要信息
    setTimeout(() => {
      queryTipsContent();
    }, 500);
  }, []);
  return (
    <div className={styles.brand_launch}>
      <div className={styles.brand_launch_tag}>{desc}</div>
      <div className={styles.brand_launch_time}>
        {/* {t('flashSales.endsIn')} */}
        {countdown ? (
          <>
            {promotionTimeText} <Countdown countdown={countdown} curTimeField={curTimeField} />
          </>
        ) : (
          promotionTimeText
        )}
      </div>
      {tipsContent && (
        <TipsArrowPopover
          content={
            <div className={styles.tipsContent}>
              <div className={styles.tipsTitle}>{title}</div>
              <div dangerouslySetInnerHTML={{ __html: tipsContent }} />
            </div>
          }
        />
      )}
      {/* <span className={styles.tips} onClick={() => tipsContent && setOpenDrawer(true)}>
        <TipSvg />
      </span>
      <UKDrawer openDrawer={openDrawer} handleClose={() => setOpenDrawer(false)} title={title}>
        <div
          className={styles.promotionContent}
          dangerouslySetInnerHTML={{ __html: tipsContent }}
        ></div>
      </UKDrawer> */}
    </div>
  );
}
